<template>
  <ubi-page-container>
    <template v-slot:page-actions>
      <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" class="inline" v-loading="loadingExport"  @click="exporter">
                    {{ $t("portals.report.exportResults") }}
      </el-button>
    </template>
    <div v-loading="loading"
         :element-loading-text="$t('portals.list.chargementDonnees')">
    <ubi-panel :title="$t('contacts.generatedByPortals')" size="sm">
      <template v-slot:left-column>
        <el-row>
          <el-col :lg="24">
            <el-row>
              <el-col :lg="24" class="mb-3">
                <el-row>
                  {{ $t("contacts.listGeneratedContactsTotal") }}
                  <el-tooltip placement="top-start" :content="$t('contacts.listTooltipTotal')">
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                  <span>&nbsp;</span><strong>{{nbContactsGeneresTotal + getNbCallsByPortal('TOTAL_CONTACTS_CALLTRACKING')}}</strong>
                </el-row>
                <el-row>
                  <br>
                  {{ $t("contacts.listGeneratedContactsMail") }}
                  <el-tooltip placement="top-start" :content="$t('contacts.listTooltipMail')">
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                  <span>&nbsp;</span><strong>{{nbContactsGeneres}}</strong>
                </el-row>
                <el-row>
                  <el-col v-if="possedeCallTracking">
                    <br />
                    {{ $t("contacts.contactsByPhone") }}
                    <el-tooltip placement="top-start" :content="$t('contacts.listTooltipTotal')">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                    <span>&nbsp;</span><strong>{{getNbCallsByPortal('TOTAL_CONTACTS_CALLTRACKING')}}</strong>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <br />
                  </el-col>
                </el-row>
                <el-row>
                  {{ $t("contacts.listAdsSent") }}
                  <strong>{{nbAnnonces}}</strong>
                </el-row>
                <el-row>
                  <el-col>
                    <br />
                  </el-col>
                </el-row>
                <el-row>
                  {{ $t("contacts.listPortalsEquippedWithCM") }}
                  <strong>{{nbPortailsCMActifs}}</strong>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </template>
      <template v-slot:right-column>
        <el-row>
          <el-col :lg="5">
            <br />
          </el-col>
          <el-col :lg="14">
            <div >
              <pie-chart style="margin-left: auto; margin-right: auto; margin-top: -55px" v-if="graphData != null" :chart-data="graphData" :options="null"></pie-chart>
              <div class="text-center" style="margin-left: auto; margin-right: auto; margin-top: 20px" v-else>{{ $t("contacts.listGraphNoData") }}</div>
              <div class="text-center"><br />{{ $t("contacts.listGraphDistributionByMail") }} <br />({{ $t("contacts.listGraphAdsSent") }})</div>
            </div>
          </el-col>
          <el-col :lg="5">
            <br />
          </el-col>
        </el-row>
      </template>
    </ubi-panel>

    <el-form @submit.prevent.native="fetchList">
      <ubi-panel style="background-color: #EBF3F2;">
        <ubi-search-container
          :filters="filters"
          @filter="doFilter"
          :defaultFilter="this.filter.presetPortals"
          v-on:resetfilter="doFilter('reset')"
          :more-opened="filter.advanced"
          @update:more-opened="advanced => setFilter({ advanced })"
        >
          <el-form-item :label="$t('general.filters.name')">
            <el-input
              type="text"
              @input="setSearch"
              :value="filter.search"
              :placeholder="$t('general.filters.adReferencePlaceholder')"
            />
          </el-form-item>
          <el-form-item :label="$t('general.filters.date')">
            <el-date-picker
              type="daterange"
              :value="filter.beforeContacts || filter.afterContacts? [
                    filter.beforeContacts || undefined,
                    filter.afterContacts || undefined
                  ] : null"
              :start-placeholder="$t('general.filters.dateCreationStart')"
              :end-placeholder="$t('general.filters.dateCreationEnd')"
              @input="
                    dates => addFilter({ beforeContacts: dates? dates[0] : null, afterContacts: dates ? dates[1] : null})
                  "
              format="dd/MM/yyyy"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('general.filters.negociateur')" v-if="filtreNegociateur()">
            <el-select
                v-model="filter.negociateur"
                @input="negociateur => addFilter({ negociateur })"
                :placeholder="$t('general.filters.negociateurPlaceholder')"
                clearable
                filterable
            >
              <el-option
                  v-for="negociateur in negociateurs"
                  :key="negociateur.id"
                  :label="negociateur.nom + ' ' + negociateur.prenom"
                  :value="negociateur.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </ubi-search-container>
      </ubi-panel>
    </el-form>
    <ubi-panel>
      <ubi-list-header
        slot="header"
        :limits="limits"
        :page.sync="pagePortals"
        :limit.sync="limit"
        :total="results.count"
        :sort.sync="sort"
        :sortProperties="sortProperties"
      ></ubi-list-header>
      <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" type="mini" slot="actions" @click="exporter" v-loading="loadingExport">
          {{ $t("contacts.exportResults") }}
      </el-button>
      <ubi-list-footer
        slot="footer"
        :limits="limits"
        :page.sync="pagePortals"
        :limit.sync="limit"
        :total="results.count"
      ></ubi-list-footer>

      <transition name="fade" v-if="infoRapprochement">
        <el-row :gutter="24">
          <BoxInfos v-if="infoRapprochement" @closeBoxInfos="closeBoxInfos" :has-icon-info="true" :has-icon-close="true" :title="$t('portals.list.reconciliationRequests')">
            {{$t('portals.list.TextReconciliation')}}
          </BoxInfos>
        </el-row >
      </transition>

      <el-table ref="table" :data="results.list" >
        <el-table-column fixed :label="$t('contacts.listColumnLogo')" min-width="100">
          <template v-slot="{ row: result }">
            <img
              alt=""
              width="80"
              :src="result.logo"
              :srcset="result.logo"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.listColumnPortal')" min-width="200">
          <template v-slot="{ row: result }">
              <strong>{{result.nom}}</strong>
          </template>
        </el-table-column>

        <el-table-column :label="$t('contacts.listColumnBusinessModel')" min-width="150">
          <template v-slot="{ row: result }">
              {{result.modeleEconomique}}
          </template>
        </el-table-column>

        <el-table-column v-if="possedeCallTracking" :label="$t('contacts.listColumnContactsMail')" min-width="100">
          <template v-slot="{ row: result }">{{result.nbContactsMailtracking}}</template>
        </el-table-column>
        <el-table-column v-if="possedeCallTracking" :label="$t('contacts.listColumnContactsTel')" min-width="100">
          <template v-slot="{ row: result }">{{result.nbContactsCalltracking}}</template>
        </el-table-column>

        <el-table-column v-if="!possedeCallTracking" :label="$t('contacts.listColumnContacts')" min-width="150">
          <template v-slot="{ row: result }">
            {{parseInt(result.nbContactsMailtracking)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.listColumnDemandesRapprochement')" align="left" min-width="200">
          <template v-slot="{ row: result }" >
              <router-link v-if="!isSubUser" :to="{ name: 'rapprochement-portals-detail', params: { portal: result.id } }"
              >
                  <div v-if="result && result.nbRapprochementsMailtracking">
                      {{result.nbRapprochementsMailtracking}}</div>
                  <div v-else>0</div>
              </router-link>
              <div v-else>
                  <div v-if="result && result.nbRapprochementsMailtracking">
                      {{result.nbRapprochementsMailtracking}}</div>
                  <div v-else>0</div>
              </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.listColumnContactsTotal')" min-width="120" class-name="column-total">
          <template v-slot="{ row: result }">
            <div v-if="!isSubUser">
              <router-link v-if="possedeCallTracking"
                           :to="{ name: 'contacts-portals-detail', params: { portal: result.id } }"
              >
                {{(parseInt(result.nbContactsMailtracking) || 0) + (parseInt(result.nbContactsCalltracking) || 0) }}
              </router-link>
              <router-link v-else :to="{ name: 'contacts-portals-detail', params: { portal: result.id } }">
                {{getNbContactById(result.id)}}
              </router-link>
            </div>
            <div v-else>
              <span v-if="possedeCallTracking"
                    :to="{ name: 'contacts-portals-detail', params: { portal: result.id } }"
              >
              {{(parseInt(result.nbContactsMailtracking) || 0) + (parseInt(result.nbContactsCalltracking) || 0) }}
              </span>
              <span v-else :to="{ name: 'contacts-portals-detail', params: { portal: result.id } }">
                   {{getNbContactById(result.id)}}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('contacts.listUniqueContacts')" min-width="130" v-if="!possedeCallTracking">
          <template v-slot="{ row: result }">
            <div v-if="result && result.nbUniqueContact">{{result && result.nbUniqueContact}}</div>
            <div v-else>0</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.listUniqueContacts')" min-width="130" v-else>
          <template v-slot="{ row: result }">
            <div v-if="result && result.nbUniqueContact">{{result.nbUniqueContact}}</div>
            <div v-else>0</div>
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('contacts.listColumnAds')" min-width="130">
          <template v-slot="{ row: result }">
            <div v-if="result._embedded && !result._embedded.diffusion">{{result._embedded.diffusion.nbAnnoncesSelectionnees}}</div>
            <div
                    v-else-if="result._embedded && (result._embedded.diffusion.nbAnnoncesMax > 0) && (result._embedded.diffusion.active == true)"
            >{{result._embedded.diffusion.nbAnnoncesSelectionnees}}/{{result._embedded.diffusion.nbAnnoncesMax}}</div>
            <div v-else>{{ $t('contacts.listColumnAdsNoActiveDiffusion') }}</div>
          </template>
        </el-table-column>
      </el-table>
    </ubi-panel>
    </div>
  </ubi-page-container>
</template>

<style lang="scss">
@import "../../theme/_bootstrap.scss";
.el-loading-spinner{
  top:10%!important;
}
/* Styles pour la colonne total */
.column-total {
  background-color: #ebf3f2; /* Vert très clair */
}
</style>

<script>
import moment from 'moment'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { Collapse, CollapseItem, Divider } from 'element-ui'
import PieChart from '../../services/piechart'
import downloadexcel from 'vue-json-excel'
import {
  exportCsvAllPortails,
  getAllPortals
} from '@/services/portals'
import {
  getContactsStatsEnTete,
  getNbCalls,
  orderNbCalls,
  generateCodeNamesList,
  getContactsPortails
} from '@/services/contacts'
import _cloneDeep from 'lodash/cloneDeep'
import BoxInfos from '@/components/ui/BoxInfos.vue'
import { getNegociateurs } from '@/services/negociateurs'
import UbiPanel from '@/components/Panel.vue'
import UbiSearchContainer from '@/components/SearchContainer.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'

export default {
  name: 'ContactsListPortals',
  inject: ['browserContext'],
  components: {
    UbiListFooter,
    UbiListHeader,
    UbiSearchContainer,
    UbiPanel,
    BoxInfos,
    PieChart,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider,
    downloadexcel
  },
  data () {
    return {
      loading: false,
      loadingExport: false,
      offset: 0,
      limits: [10, 10 * 2, 10 * 5],
      enTete: null,
      enTeteCMPortals: null,
      nbResults: 0,
      callsPerPortal: null,
      sortProperties: {
        nom: this.$t('general.sort.name'),
        contact: this.$t('general.sort.contactEmail'),
        contactTel: this.$t('general.sort.contactTel'),
        annonces: this.$t('general.sort.ads')
      },
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      nbPortailsActifs: 0,
      nbPortailsCMActifs: 0,
      graphData: null,
      filters: [
        { value: 'allPortals', label: this.$t('general.filters.allPortals') },
        { value: 'withContacts', label: this.$t('general.filters.portalsWithContacts') },
        { value: 'sanscontacts', label: this.$t('general.filters.portalsWithoutContact') },
        { value: 'gratuits', label: this.$t('general.filters.freePortals') },
        { value: 'payants', label: this.$t('general.filters.paidPortals') }
        // { value: "new", label: this.$t("Spécialisés « neufs »") }
      ],
      responseDataStats: null,
      contactsPortails: null,
      codenamesWithContacts: '',
      infoRapprochement: true,
      negociateurs: []
    }
  },
  computed: {
    ...mapState('contactsListPortals', ['filter', 'results']),
    ...mapGetters(['isSubUser', 'getPickerOptionsShortcuts']),
    ...mapGetters('contactsListPortals', ['getNbContactById']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeCallTracking () {
      return this.sitimmoUser.possede_call_tracking
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    pagePortals: {
      get () {
        return this.filter.pagePortals
      },
      set (value) {
        this.setOffsetPortals((value - 1) * this.limit)
        this.setPagePortals(value)
        this.fetchList()
        return this.setPagePortals(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffsetPortals(0)
        this.setPagePortals(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffsetPortals(0)
        this.setPagePortals(1)
        this.fetchList()
        return this.setSort(value)
      }
    }
  },
  beforeMount () {
    this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
    if (this.sitimmoUser.possede_call_tracking === false) {
      delete this.sortProperties.contactTel
    }
    if (this.filtreNegociateur()) {
      this.callNegociateurs()
    }
  },
  methods: {
    closeBoxInfos (args) {
      if (args === 'close') {
        this.infoRapprochement = false
      }
    },
    eventAnalytics (category) {
      this.$ga.event('contact_manager_portails', 'clic', category, this.sitimmoUser.id)
    },
    formatExport (list, dataStats) {
      const finalList = []
      list.forEach((element) => {
        const tabPortail = {}
        tabPortail.nom_partenaire = element.nom
        tabPortail.actif = element.actif
        tabPortail.modeleEconomique = element.modeleEconomique
        if (element._embedded && element._embedded.diffusion) {
          tabPortail.nbAnnoncesEnvoyees = element._embedded.diffusion.nbAnnoncesEnvoyees
        } else {
          tabPortail.nbAnnoncesEnvoyees = 'Pas de diffusion active'
        }
        for (const [key, value] of Object.entries(dataStats.infos)) {
          if (key === element.nom_de_code) {
            tabPortail.nbContactsMailtracking = value.nbContactType
            tabPortail.nbRapprochementsMailtracking = value.nbRapprochementType
            tabPortail.nbUniqueContact = value.nbUniqueContact
          }
        }
        // tabPortail.nbContactsMailtracking = element.nbContactsMailtracking
        tabPortail.nbContactsCalltracking = element.nbContactsCalltracking.nb_calls
        finalList.push(tabPortail)
      })
      return finalList
    },
    async exporter () {
      this.loading = true
      const filename = this.$t('contacts.filenameExportContactsPortals')
      const res = await exportCsvAllPortails(this.filter, null, this.sitimmoUser.possede_call_tracking, filename)
      this.$message(res)
      this.loading = false
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('contactsListPortals', [
      'setPage',
      'setOffsetPosts',
      'setPagePortals',
      'setOffsetPortals',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter',
      'setBeforeContacts',
      'setAfterContacts',
      'setCodeNames',
      'setRapprochement'
    ]),
    handleClose (done) {
      this.$confirm(this.$t('general.exitConfirmation'))
        .then(_ => {
          done()
        })
        .catch(_ => {
          //
        })
    },
    formatPortalCodenames (portalsStats) {
      let strCodeNames = ''
      let i = 0
      for (const [key, value] of Object.entries(portalsStats)) {
        if (i > 0) {
          strCodeNames = strCodeNames + ','
        }
        strCodeNames = strCodeNames + key
        i++
      }
      return strCodeNames
    },
    doFilter (type) {
      switch (type) {
        case 'allPortals':
          this.filter.gratuit = null
          this.filter.withContacts = null
          this.filter.codeNames = null
          this.filter.excludedCodeNames = null
          this.filter.search = ''
          this.filter.sort = 'nom'
          this.filter.sanscontacts = null
          this.setFilter(this.filter)
          break
        case 'gratuits':
          this.filter.gratuit = 'O'
          this.filter.codeNames = null
          this.filter.withContacts = null
          this.filter.excludedCodeNames = null
          this.filter.sort = 'nom'
          this.filter.sanscontacts = null
          this.setFilter(this.filter)
          break
        case 'payants':
          this.filter.gratuit = 'N'
          this.filter.withContacts = null
          this.filter.excludedCodeNames = null
          this.filter.sort = 'bom'
          this.filter.sanscontacts = null
          this.setFilter(this.filter)
          break
        case 'sanscontacts':
          this.filter.sanscontacts = 'O'
          this.filter.codeNames = null
          this.filter.excludedCodeNames = this.codenamesWithContacts
          this.filter.sort = 'nom'
          this.filter.gratuit = null
          this.filter.sanscontacts = null
          this.setFilter(this.filter)
          break
        case 'withContacts':
          this.filter.sanscontacts = null
          this.filter.excludedCodeNames = null
          this.filter.codeNames = this.codenamesWithContacts
          this.filter.sort = 'nom'
          this.filter.gratuit = null
          this.filter.sanscontacts = null
          this.setFilter(this.filter)
          break
        case 'reset':
          type = 'withContacts'
          this.filter.gratuit = true
          this.filter.beforeContacts = moment().subtract(7, 'days')
          this.filter.afterContacts = moment()
          this.filter.excludedCodeNames = null
          this.filter.codeNames = this.codenamesWithContacts
          this.filter.search = ''
          this.filter.sort = 'nom'
          this.filter.sanscontacts = null
          this.setFilter(this.filter)
          // this.setFilter({ search:"", beforeContacts: moment().subtract(7, 'days'), afterContacts: moment(), sort: 'contact', sanscontacts: null, withContacts: null, gratuit: null });
          break
      }
      this.filter.presetPortals = type
      this.fetchList()
    },
    async fetchList () {
      console.log(this.filter.beforeContacts)
      console.log(this.filter.afterContacts)
      this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      // No need to interrupt promises when the router changes...
      this.loading = true
      this.setRapprochement(null)
      this.setPage(this.filter.pagePortals)

      const self = this

      const clonedFilters = _cloneDeep(this.filter)
      clonedFilters.privatePortal = false
      if (this.filter.negociateur) {
        clonedFilters.negociateur_code = this.filter.negociateur
      }

      const dataStats = getContactsStatsEnTete(clonedFilters)

      if (dataStats.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }

      // const allPortals = getAllPortals(clonedFilters)
      // if (allPortals.type === 'error') {
      //   this.loading = false
      //   return false
      // }
      const contactsPortails = getContactsPortails(clonedFilters)
      if (contactsPortails.type === 'error') {
        this.loading = false
        return false
      }
      let nbCalls = getNbCalls(this.filter, null)
      if (nbCalls.type === 'error') {
        this.loading = false
        return false
      }

      await Promise.all([dataStats, contactsPortails, nbCalls])
        .then(function (results) {
          if (results) {
            self.contactsPortails = results[1].infos
            nbCalls = results[2]
            self.callsPerPortal = orderNbCalls(nbCalls)
            if (self.sitimmoUser.possede_call_tracking === true) {
              const codeNames = generateCodeNamesList(nbCalls)
              self.setCodeNames(codeNames)
            }
            // self.setResults(results[3])

            self.responseDataStats = results[0].infos
          }
        }, self)
      this.$store.commit('contactsListPortals/setPortalsCM', this.contactsPortails)
      this.nbContactsGeneres = this.responseDataStats.nbContactsGeneres
      this.nbContactsGeneresTotal = this.responseDataStats.nbContactsGeneresTotal
      this.nbAnnonces = this.responseDataStats.nbAnnonces
      this.nbProspects = this.responseDataStats.nbProspects
      this.nbPortailsActifs = this.responseDataStats.nbPortailsActifs
      this.nbPortailsCMActifs = this.responseDataStats.nbPortailsCMActifs
      this.codenamesWithContacts = this.formatPortalCodenames(this.contactsPortails)

      let allPortals = null

      if (clonedFilters.presetPortals === 'withContacts') {
        clonedFilters.codeNames = this.codenamesWithContacts
        clonedFilters.privatePortal = 'O'
        if (this.codenamesWithContacts === '') {
          allPortals = {
            total: 0,
            count: 0,
            list: [],
            page_count: 0,
            items_per_page: 0,
            page: 1,
            results: [],
            portals: [],
            type: 'success'
          }
        } else {
          allPortals = await getAllPortals(clonedFilters)
        }
        self.setResults(allPortals)
      }
      if (clonedFilters.presetPortals === 'sanscontacts') {
        clonedFilters.excludedCodeNames = this.codenamesWithContacts
        clonedFilters.privatePortal = 'O'
        allPortals = await getAllPortals(clonedFilters)
        self.setResults(allPortals)
      }
      const labels = []
      const values = []
      const portals = Object.values(
        this.responseDataStats.infosPortails
      )
      portals.forEach(function (element) {
        labels.push(element.nom)
        values.push(element.nb_contacts)
      })
      this.graphData = {
        labels: labels,
        datasets: [
          {
            label: '# of Votes',
            data: values,
            borderWidth: 0,
            labelWidth: 1000,
            backgroundColor: [
              'rgba(255, 99, 132, 0.55)',
              'rgba(54, 162, 235, 0.55)',
              'rgba(255, 206, 86, 0.55)',
              'rgba(75, 192, 192, 0.55)',
              'rgba(153, 102, 255, 0.55)',
              'rgba(255, 159, 64, 0.55)'
            ]
          }
        ]
      }

      const reducer = (accumulator, currentValue) => accumulator + currentValue
      if (values.length > 0) {
        if (values.reduce(reducer) == 0) {
          this.graphData = null
        }
      } else {
        this.graphData = null
      }
      if (this.results.list) {
        this.results.list.forEach(function (element) {
          const codename = element.nom_de_code
          element.nbContactsCalltracking = 0
          for (const [key, value] of Object.entries(self.contactsPortails)) {
            if (key === codename) {
              element.nbContactsMailtracking = value.nbContactType
              element.nbRapprochementsMailtracking = value.nbRapprochementType
              element.nbUniqueContact = value.nbUniqueContact
            }
          }
          for (const [key, value] of Object.entries(nbCalls.infos)) {
            if (value.diffuseur === codename) {
              element.nbContactsCalltracking = value.nb_calls
            }
          }
        }, self)
      }

      this.loading = false
    },
    getNbCallsByPortal (nomDeCodePortal) {
      if (this.callsPerPortal && this.callsPerPortal[nomDeCodePortal]) {
        return parseInt(this.callsPerPortal[nomDeCodePortal])
      } else {
        return 0
      }
    },
    async callNegociateurs () {
      this.filter.negociateur = null
      this.filter.reseau = 'EXP FRANCE'
      this.negociateurs = await getNegociateurs(this.filter)
    },
    filtreNegociateur () {
      return ((this.sitimmoUser.id == 342878) || this.sitimmoUser.betaTesteur)
    }
  }
}
</script>
